import React, { useEffect, useState } from 'react';
import  "./App.css"
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Landing from './pages/Home/Landing';
import { Service } from './pages/Service/Service';
import ForgotPassword from './pages/Login/ForgotPassword';
import ResetPassword from './pages/SignUp/ResetPassword';
// import Dashboard from './pages/Dashboard/Dashboard';
import Oath from './pages/Oath/Oath';
import InvoiceNew from './pages/Users/InvoiceNew';
// import SocialRegisterDashboard from './pages/New Dashboard/SocialRegisterDashboard';
import RegisterPage from './pages/Register/Register';
// import PersonalReg from './pages/Register/PersonalReg';
// import StaffReg from './pages/Register/StaffReg';
// import Logins from './pages/Register/Login';
import Login from './pages/Register/Login';
import NinReg from './pages/Register/NinReg';
import Registration from './pages/Register/Registration';
import HouseholdMembers from './pages/HouseHold/HouseHold';
import ApplicationStatus from './pages/Application Status/Staus';
import Assistance from './pages/Assistance/Assistance';
import HouseholdDashboard from './pages/Dashboard/HouseholdDashboard';
import Profile from './pages/Profile/Profile';



function App() {

  return (
    <BrowserRouter>
  <Routes>
    <Route path="/" element={<Landing />} />
    <Route path="/forgot_password" element={<ForgotPassword />} />
    <Route path="/reset_password" element={<ResetPassword />} />
    <Route path="/service" element={<Service />} />
    {/* <Route path="/vendor_registration" element={<Dashboard />} /> */}
    <Route path="/vendor_oath" element={<Oath />} />
    {/* <Route path="/dashboard" element={<SocialRegisterDashboard />} /> */}
    <Route path="/view_invoice" element={<InvoiceNew />} />

    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<RegisterPage />} />
    <Route path="/nin_reg" element={<NinReg />} />
    <Route path="/registration" element={<Registration />} />
    <Route path="/household" element={<HouseholdMembers />} />
    <Route path="/application_status" element={<ApplicationStatus />} />
    <Route path="/assistance" element={<Assistance />} />
    <Route path="/dashboard" element={<HouseholdDashboard />} />
    <Route path="/profile" element={<Profile />} />
    {/* <Route path="/household-registration" element={<PersonalReg />} />
    <Route path="/government-registration" element={<StaffReg />} /> */}
  </Routes>
</BrowserRouter>

  );
}

export default App;
